import { Button } from '@getinapp/appetizer';
import ReactCodeInput from 'react-code-input';
import { useCheckOtpCodeHook } from './hooks';
import { Row } from 'react-grid-system';
import * as S from './styles';
import { useMemo } from 'react';

export const CheckOtpCode = () => {
  const {
    code,
    session,
    isLoading,
    currentFlow,
    remainingTime,
    isOpenModal,
    isUserDuplicateOpen,
    handleClickButtonBack,
    handleCloseCheckOtpCodeModal,
    handleNotReceiveTheCodeButton,
    setCode,
    t,
  } = useCheckOtpCodeHook();

  const optionsText = useMemo(() => {
    return {
      sms: t('@CheckOTPCode.insert-your-six-digits-code-sms', {
        mobile: session?.phone,
      }),
      email: t('@CheckOTPCode.insert-your-six-digits-code-email', {
        email: session?.email,
      }),
    };
  }, [session, t]);

  return (
    <S.Modal
      width="15%"
      title={
        <S.Title>
          {isUserDuplicateOpen
            ? t('@CheckOTPCode.activate-your-account')
            : t('@CheckOTPCode.verification-code')}
        </S.Title>
      }
      isOpen={isOpenModal}
      onRequestClose={() => handleCloseCheckOtpCodeModal()}
    >
      <S.Paragraph>
        {isUserDuplicateOpen
          ? optionsText['email']
          : optionsText[currentFlow as keyof typeof optionsText]}
      </S.Paragraph>

      <Row align="center" justify="center">
        <ReactCodeInput
          name="code"
          inputMode="numeric"
          type="tel"
          fields={6}
          value={code}
          onChange={(value) => {
            if (parseInt(value)) setCode(value);
          }}
        />
      </Row>

      {remainingTime > 0 ? (
        <S.CountdownParagraph disabled={remainingTime > 0}>
          {isUserDuplicateOpen
            ? t('@CheckOTPCode.resend-code-email')
            : t('@CheckOTPCode.not-receive-the-code')}{' '}
          ({remainingTime}...)
        </S.CountdownParagraph>
      ) : (
        <S.CountdownParagraph
          disabled={remainingTime > 0}
          onClick={handleNotReceiveTheCodeButton}
        >
          {isUserDuplicateOpen
            ? t('@CheckOTPCode.resend-code-email')
            : t('@CheckOTPCode.not-receive-the-code')}
        </S.CountdownParagraph>
      )}

      <Button isFullWidth loading={isLoading} disabled={code.length < 6}>
        {t('@CheckOTPCode.advance')}
      </Button>

      <S.BackButton onClick={handleClickButtonBack}>
        <span>{'<-'}</span>
        {t('@CheckOTPCode.back')}
      </S.BackButton>
    </S.Modal>
  );
};
